module.exports = __webpack_public_path__ + "img/certificate-1.919cc23d.jpg";